import React from "react";
import { Box } from "@mui/material";
export function DataTableHeader({ children }) {
    return (React.createElement(Box, { p: 2, display: "flex", alignItems: "center" }, children));
}
//# sourceMappingURL=DataTableHeader.js.map